const Warning = ({
  className = "",
  color,
  secondaryColor,
}: {
  className?: string;
  color: string;
  secondaryColor?: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path data-name="layer2" fill={color} d="M2.86 8.101v40h18v11.024l12-11.024h30v-40h-60z"></path>
    <path
      data-name="layer1"
      d="M34.86 32.125a2.025 2.025 0 0 1-2 2 2.227 2.227 0 0 1-2-2l-1-15a2.779 2.779 0 0 1 3-3 2.652 2.652 0 0 1 3 3z"
      fill={secondaryColor}
    ></path>
    <circle data-name="layer1" cx="32.86" cy="40.125" r="2" fill={secondaryColor}></circle>
  </svg>
);

export default Warning;
